import { useContext } from 'react';

import { useStore } from 'zustand';

import { AuthStoreContext } from '../providers/AuthStoreProvider';
import type { AuthStore } from '../stores/authStore';

function useAuthStore<T>(selector: (store: AuthStore) => T): T {
    const authStoreContext = useContext(AuthStoreContext);

    if (!authStoreContext) {
        throw new Error('useAuthStore must be used within AuthStoreProvider');
    }

    return useStore(authStoreContext, selector);
}

export default useAuthStore;
